import { ReactNode, useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useAppSelector } from "redux/hooks";
import { Typography } from "antd";
import Card from "components/layout/Card";
import { Footer } from "antd/lib/layout/layout";
import style from "./style.module.css";
import { loginComponent } from "utils/AssetsData";

const { Text } = Typography;

interface PageLayoutProps {
  children: ReactNode;
  isSingleCard?: boolean;
}

const PageLayout = ({ children, isSingleCard = true }: PageLayoutProps): JSX.Element => {
  const { t } = useTranslation();
  const thisYear = new Date().getFullYear();
  const [hasWhiteLabel, setHasWhiteLabel] = useState<boolean>(false);
  const { whiteLabel = "", loading } = useAppSelector(state => state.properties);

  useEffect(() => {
    setHasWhiteLabel(!loading && whiteLabel?.length > 0);
  }, [loading, whiteLabel]);

  const handleClickLogo = useCallback(() => {
    location.reload();
  }, []);

  return (
    <div className={style["page-container"]}>
      <div className={style["page-contents"]}>
        <button className="invisible-btn" onClick={handleClickLogo} style={{ marginBottom: 20 }}>
          {hasWhiteLabel ? (
            <img src={loginComponent[whiteLabel].logo} alt={"Reload page"} />
          ) : (
            <></>
          )}
          <p style={{ marginTop: "1rem" }}>{t("login.headerTitle")}</p>
        </button>
        <Card className={isSingleCard ? style["single-card"] : style["double-card"]}>
          {children}
        </Card>
      </div>
      <Footer className={style["footer"]}>
        <div className={style["footer-container"]}>
          <Text className={style["footer-entry"]}>
            {t("footer.copyright", { year: thisYear })} {process.env.REACT_APP_RELEASE_VERSION}
          </Text>{" "}
          <Text className={style["footer-entry"]}>{t("footer.ACN")}</Text>
          <Text className={style["footer-entry"]}>{t("footer.ABN")}</Text>
        </div>
      </Footer>
    </div>
  );
};

export default PageLayout;
